import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'
import { fakeUrl } from '@/helpers/functions/fakeDataStats'

export default {
  namespaced: true,
  state: {
    loadingGoogle: false,
    isDataGoogleReady: false,
    statisticsGoogle: [
      {
        dailyMetric: 'BUSINESS_IMPRESSIONS_MOBILE_SEARCH',
        timeSeries: {
          datedValues: []
        },
        totalMetric: 0
      },
      {
        dailyMetric: 'BUSINESS_IMPRESSIONS_MOBILE_MAPS',
        timeSeries: {
          datedValues: []
        },
        totalMetric: 0
      },
      {
        dailyMetric: 'BUSINESS_IMPRESSIONS_DESKTOP_SEARCH',
        timeSeries: {
          datedValues: []
        },
        totalMetric: 0
      },
      {
        dailyMetric: 'BUSINESS_IMPRESSIONS_DESKTOP_MAPS',
        timeSeries: {
          datedValues: []
        },
        totalMetric: 0
      },
      {
        dailyMetric: 'IMPRESSIONS_TOTAL',
        timeSeries: {
          datedValues: []
        },
        totalMetric: 0
      },
      {
        dailyMetric: 'WEBSITE_CLICKS',
        timeSeries: {
          datedValues: []
        },
        totalMetric: 0
      },
      {
        dailyMetric: 'BUSINESS_DIRECTION_REQUESTS',
        timeSeries: {
          datedValues: []
        },
        totalMetric: 0
      },
      {
        dailyMetric: 'CALL_CLICKS',
        timeSeries: {
          datedValues: []
        },
        totalMetric: 0
      },
      {
        dailyMetric: 'BUSINESS_CONVERSATIONS',
        timeSeries: {
          datedValues: []
        },
        totalMetric: 0
      }
    ]
  },
  getters: {
    getLoadingGoogle: (state) => state.loadingGoogle,
    getDatedValuesByMetric: (state) => (metric) => {
      const entry = state.statisticsGoogle.find((item) => item.dailyMetric === metric)
      return entry ? entry.timeSeries.datedValues : []
    },
    getTotalMetricByMetric: (state) => (metric) => {
      const entry = state.statisticsGoogle.find((item) => item.dailyMetric === metric)
      return entry ? entry.totalMetric : 0
    },
    getIsDataGoogleReady: (state) => state.isDataGoogleReady
  },
  mutations: {
    setLoadingGoogle (state, bool) {
      state.loadingGoogle = bool
    },
    populateStatistics (state, payload) {
      const { success, data } = payload
      if (success) {
        if (!data || !Array.isArray(data)) return
        state.statisticsGoogle = data
      }
    },
    setIsDataGoogleReady (state, bool) {
      state.isDataGoogleReady = bool
    }
  },
  actions: {
    loadStatisticsGoogle (context) {
      context.commit('setLoadingGoogle', true)
      const path = fakeUrl('/google/statistics', '/fake/statistics/google')
      HTTP_HYPER_ESPACE_BACKEND.get(path)
        .then((response) => {
          context.commit('setIsDataGoogleReady', response.data.success)
          if (response.data.success) {
            context.commit('populateStatistics', response.data)
          }
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          context.commit('setLoadingGoogle', false)
        })
    }
  }
}
